// The failure state for the EA panels.
//
// WHY THIS IS NOT AN EMPTY STATE
// ==============================
// CLAUDE.md Part 2 §17.6: a failure, a refusal and a genuine empty result must
// never look identical. Rendering "nothing needs you" when the read actually
// failed is the exact mistake that rule exists to prevent — the owner would
// read a broken screen as good news. So a failed read says it failed, and says
// what the server said, rather than borrowing the empty state's calm.
import React from "react";

export default function PanelError({ error }) {
  return (
    <div className="ea-panel-error" role="alert">
      <div className="ea-panel-error-title">This did not load</div>
      <div className="ea-panel-error-detail dim">
        {error || "The request failed."}
      </div>
      <div className="ea-panel-error-note dim">
        This is a failure, not an empty list. What is here is unknown, not nothing.
      </div>
    </div>
  );
}
